import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const setSkillMapLines = api(async function setSkillMapLines({ skillMapId, lines }) {
    return mutate(
        gql`
            mutation SetSkillMapLines($skillMapId: String!, $lines: [SkillMapLineInput!]!) {
                setSkillMapLines(skillMapId: $skillMapId, lines: $lines)
            }
        `,
        { skillMapId, lines },
        { returns: "setSkillMapLines" }
    )
})
